import React, { useState } from 'react';
import './CalculatorPage.css';

function LuckyGemsColorsSuggestion() {
  const [dob, setDob] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const getSuggestions = (dateString) => {
    // Placeholder for Lucky Gems & Colors Suggestion logic
    // This is a simplified example; real suggestions would be more complex.
    const digitsOnly = dateString.replace(/\D/g, '');

    if (digitsOnly.length !== 8) {
      return null; // Invalid length
    }

    let sum = 0;
    for (let i = 0; i < digitsOnly.length; i++) {
      sum += parseInt(digitsOnly[i], 10);
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }

    let gem = "";
    let color = "";

    switch (sum) {
      case 1:
        gem = "Ruby";
        color = "Red";
        break;
      case 2:
        gem = "Pearl";
        color = "White";
        break;
      case 3:
        gem = "Yellow Sapphire";
        color = "Yellow";
        break;
      case 4:
        gem = "Gomed";
        color = "Blue";
        break;
      case 5:
        gem = "Emerald";
        color = "Green";
        break;
      case 6:
        gem = "Diamond";
        color = "Pink";
        break;
      case 7:
        gem = "Cat's Eye";
        color = "Grey";
        break;
      case 8:
        gem = "Blue Sapphire";
        color = "Dark Blue";
        break;
      case 9:
        gem = "Red Coral";
        color = "Orange";
        break;
      default:
        gem = "N/A";
        color = "N/A";
    }

    return { gem, color, number: sum };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(dob)) {
      setError('Please enter a valid date in DD/MM/YYYY format.');
      return;
    }

    const calculated = getSuggestions(dob);
    if (calculated === null) {
      setError('Invalid date. Please check your input.');
    } else {
      setResult(calculated);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Lucky Gems & Colors Suggestion",
    "description": "Discover your lucky gems and colors based on your birth date and numerology.",
    "url": "https://www.yourwebsite.com/lucky-gems-colors-suggestion",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Get Lucky Gems & Colors",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/lucky-gems-colors-suggestion?dob={dob}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=dob"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Lucky Gems & Colors Suggestion</h1>
      <p className="text-center">Enter your Date of Birth to get suggestions for your lucky gems and colors.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="dob">Date of Birth (DD/MM/YYYY):</label>
          <input
            type="text"
            id="dob"
            className="form-control"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            placeholder="e.g., 01/01/1990"
            maxLength="10"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Get Suggestions</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Lucky Number: <span className="result-number">{result.number}</span></h2>
          <p className="result-explanation">Based on your birth date, your lucky gem is <strong>{result.gem}</strong> and your lucky color is <strong>{result.color}</strong>.</p>
        </div>
      )}
    </div>
  );
}

export default LuckyGemsColorsSuggestion;
